'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function progressBar(testId, properties) {
    return {
        id: 'progress-bar',
        component: 'magic-ui-step-progress-bar',
        isDataField: false,
        testId: testId,
        properties: properties,
    };
}
function progressBar1of3() {
    return progressBar('step1-progress', {
        'steps': 3,
        'current-step': 1,
    });
}
function progressBar2of3() {
    return progressBar('step2-progress', {
        'steps': 3,
        'current-step': 2,
    });
}

exports.progressBar = progressBar;
exports.progressBar1of3 = progressBar1of3;
exports.progressBar2of3 = progressBar2of3;
